import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTreatmentAreasOld = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/cms/treatment_areas_old/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetTreatmentAreasOld = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["treatment_areas_old"],
    queryFn: fetchTreatmentAreasOld,
    enabled,
  });
};

export default useGetTreatmentAreasOld;
